<template>
    <v-card
            v-show="state.length > 0"
            flat
            class="notification-container-floating"
            :class="notificationContainerFloatingClass"
    >
        <v-flex
                v-for="notification in state"
                class="notification-subcontainer-floating"
        >
            <Notification
                    v-show="(!notification.dismissed && !notification.expired)"
                    :notification="notification"
            />
        </v-flex>
    </v-card>
</template>
<script>
    import {mapGetters, mapState,} from "vuex";
    import Notification from "@/components/GlobalControls/Notifications/Notification";

    export default {
        name: "GlobalNotificationsFloating",
        components: {Notification,},
        props: ["state",],
        data() {
            return {};
        },
        computed: {
            ...mapState({}),
            ...mapGetters("AppState", {
                    isGlobalNotificationsPanel: "isGlobalNotificationsPanel",
                }
            ),
            notificationContainerFloatingClass() {
                let styleClass = "";
                if (this.$vuetify.breakpoint.name === "xs") {
                    styleClass = "notification-container-floating-xs";
                } else {
                    styleClass = "notification-container-floating-sm";
                }
                return styleClass;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .notification-container-floating {
        z-index: 25;
        background-color: transparent;
        position: fixed;
        overflow-y: auto;
        padding: 2px;
        top: 48px;
        right: 8px;
        max-height: 70vh;
        margin-top: 10px;
    }

    .notification-subcontainer-floating {
        margin-bottom: 5px;
    }

    .notification-container-floating-sm {
        width: 404px;
    }
    .notification-container-floating-xs {
        left: 0;
        right: 0;
        margin-left: 8px;
        margin-right: 8px;
        width: calc(100% - 16px);
    }

</style>
